<template>
  <div style="display: flex; align-items: flex-start">
    <sidebar style="margin-right: 20px; max-width: 200px"/>
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Todo ismétlődő szabályok</span>
      </div>
      <list />
      <template v-if="$route.meta.showAddTodoRecurringPatternDialog">
        <pattern-dialog
          type="add"
        />
      </template>
      <template v-if="$route.meta.showUpdateTodoRecurringPatternDialog">
        <pattern-dialog
          :pattern-id="$route.params.id"
          type="update"
        />
      </template>
    </el-card>
  </div>
</template>

<script>
import List from '../../components/todos/recurringPatterns/List';
import PatternDialog from '../../components/todos/recurringPatterns/Dialog';
import Sidebar from '../../components/todos/Sidebar';

export default {
  components: {
    List,
    PatternDialog,
    Sidebar,
  },
};
</script>
